// 業務報告書
$(() => {
    if (document.getElementById('partner-report-form') != null) {
        $('.submission-exec').click(function(){
            $('#submission_comment').val($('#modal_submission_comment').val());
            $('#submission').submit();
        });
    }

    // 任意提出日の制御
    $('#indicate_date_check').on('change', () => {
        if ($("#indicate_date_check").prop("checked") === true) {
            $("#indicate_date").show();
        }else{
            $("#indicate_date").hide();
        }
    });
});